import { Navigate, Route } from "react-router-dom";

import SavedPosts from "features/main/Home/SavedPosts";
import SavedLoads from "features/main/Home/SavedPosts/Loads";
import SavedTrucks from "features/main/Home/SavedPosts/Trucks";
import { useUserFeature } from "hooks/useUserFeature";

export default function SavedPostsRoutes() {
  const { isShipper, isSavedLoadsRole } = useUserFeature();

  return (
    <Route path="saved" element={<SavedPosts />}>
      <Route path="" element={<Navigate to={isShipper ? "trucks" : "loads"} />} />
      {!isShipper && <Route path="loads" element={<SavedLoads />} />}
      {isSavedLoadsRole && <Route path="trucks" element={<SavedTrucks />} />}
    </Route>
  );
}
